import styled from 'styled-components';

import ds from 'designsystem';
import { media } from 'designsystem/index';

const StyledLink = styled.a`
  text-decoration: none;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
    outline: none;
  }
  ${media.desktop`
    margin-bottom: ${ds.get('metrics.xs')};
  `};
`;

export default StyledLink;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ArticleSlider/ArticleSlide/StyledLink.jsx